export let QueryId = /*#__PURE__*/function (QueryId) {
  QueryId["DocumentServicesData"] = "document-services-data-query";
  QueryId["SiteData"] = "site-data-query";
  QueryId["VerticalsData"] = "verticals-data-query";
  QueryId["RulesData"] = "rules-data-query";
  QueryId["GalleryData"] = "gallery-data-query";
  QueryId["ProductPages"] = "product-pages-data-query";
  QueryId["ServicePages"] = "service-pages-data-query";
  QueryId["BlogPosts"] = "blog-posts-data-query";
  QueryId["Events"] = "events-data-query";
  QueryId["Portfolio"] = "portfolio-data-query";
  QueryId["OnlinePrograms"] = "online-programs-data-query";
  QueryId["RestaurantsMenu"] = "restaurants-menu-data-query";
  QueryId["Groups"] = "groups-data-query";
  QueryId["AnalyzeFullSite"] = "analyze-full-site-data-query";
  QueryId["WixVideoData"] = "wix-video-data-query";
  QueryId["QueryRuleExecutionResults"] = "query-rule-execution-results-data-query";
  QueryId["QueryRuleExecutionResultsByJob"] = "query-rule-execution-results-by-job-data-query";
  return QueryId;
}({});
//# sourceMappingURL=types.js.map